<template>

  <div>
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="loading_page" v-if="loading">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>
      <div class="m-2">
        <plan-form :on-submit="onSubmit" :work-area-items="form.work_areas" :plan-data="form" :errors="errors">
        </plan-form>
      </div>
    </b-card>
    <b-row>
      <b-col cols="12" class="mt-5">
        <b-card no-body class="mb-0">
        <b-row>
          <b-col  cols="4">
            <CollapseableTimeLine  :params="{commentable:'plan',commentable_id:$route.params.id}"  class="mt-5"/>
          </b-col>
        </b-row>
        </b-card>
      
     </b-col>
    </b-row>

  </div>
</template>

<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BFormInvalidFeedback,
  BBadge, BDropdown, BDropdownItem, BPagination, BForm, BFormGroup, BFormCheckboxGroup, BCollapse
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { onUnmounted, } from '@vue/composition-api'
import store from '@/store'
import PlanListAddNew from '@/views/modules/plans/garden-plan/plans-list/PlanListAddNew'
import AreaFormRepeater from '@/components/form/AreaFormRepeater'
import flatPickr from 'vue-flatpickr-component'
import Ripple from "vue-ripple-directive"
import PlanForm from './share/PlanForm'
import PlanStore from '../functions/plansStore'
import usePestPlan from './share/usePestPlan'
import router from '@/router'

//time line for editing events

import CollapseableTimeLine from '@core/components/app-timeline/CollapseableTimeLine.vue'

export default {
  components: {
    OrbitSpinner, AreaFormRepeater, flatPickr, BFormInvalidFeedback,
    BCard, BRow, BCol, BFormInput, BButton, BTable, BFormCheckboxGroup,
    BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination,
    vSelect, PlanListAddNew, BForm, BFormGroup,
    PlanForm,

    CollapseableTimeLine,
    BCollapse
  },
  directives: {
    Ripple,
  },

  setup(props, { root }) {

    if (!store.hasModule('plans'))
      store.registerModule('plans', PlanStore)

    onUnmounted(() => {
      if (store.hasModule('plans'))
        store.unregisterModule('plans')
    })

    const { loading, fetchPlan,fetchPlanComments,comments, form, errors } = usePestPlan()
   

    fetchPlan(router.currentRoute.params.id)
   // fetchPlanComments({commentable:'plan',commentable_id:router.currentRoute.params.id})

    const onSubmit = () => {


      store.dispatch('plans/updatePlan', form.value)
        .then(r => {
          root.$bvToast.toast(root.$t('rain plan updated successfully'), {
            title: root.$t("success"),
            variant: 'success',
            solid: false,
          })
        }).catch(reason => {
          if (reason.response.status === 422)
            errors.value = reason.response.data.errors
        }).finally(() => loading.value = false)
    }


    return {
      onSubmit,
      loading,
      form,
      errors,
      comments,
    }

  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.per-page-selector {
  width: 90px;
}

.actionIcon>button {
  padding: 0;
}
</style>
